import { INITIALIZE_ASSIGN_USER_FORM } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (values) =>
    creditFileActions[INITIALIZE_ASSIGN_USER_FORM](values);
